/**
 * Mappers for area create operations
 */

import type {
  CreateAreaRequest,
  CreateAreaResult,
  LC_CreateCompanyAreaIn,
  LC_CreateCompanyAreaOut,
} from '../types';

/**
 * Map create area request from domain to transport
 */
export function mapCreateAreaToTransport(
  request: CreateAreaRequest,
): LC_CreateCompanyAreaIn {
  return {
    areaCode: request.code,
    areaName: request.name,
    parentAreaId: request.parentAreaId,
  };
}

/**
 * Map create area response from transport to domain
 */
export function mapCreateAreaFromTransport(
  transport: LC_CreateCompanyAreaOut,
): CreateAreaResult {
  return {
    id: transport.areaId,
    code: transport.areaCode,
    name: transport.areaName,
    parentAreaId: transport.parentAreaId,
    parentAreaName: transport.parentAreaName,
    isEnabled: transport.isEnabled,
    createdDate: transport.createdDate,
    createdBy: transport.createdBy,
  };
}
